import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import productrecalldataaccess from "src/dataAccess/products/productrecalldataaccess";

interface IListType {
  pageNo: number;
  pageSize: number;
  sortData: string;
  filters: any[];
}

export const loading = createAction<boolean>(
  "[Product Recall] Loading Product Recall list"
);

export const getListActionSuccess = createAction<any>(
  "[Product Recall]  Get Product Recall list Success"
);
export const getListActionAsync = createAsyncThunk<string, IListType>(
  "[Product Recall] Get Product Recall list",
  async (parameter: IListType, thunkAPI) => {
    thunkAPI.dispatch(loading(true));

    const result = await productrecalldataaccess
      .getList(parameter)
      .then((res) => {
        thunkAPI.dispatch(loading(false));
        thunkAPI.dispatch(getListActionSuccess(res));
        return res;
      });
    return result;
  }
);
